import React, { useEffect, useState, Fragment } from 'react';
import Events from './Events';
import SelectCompressionMode from './components/SelectCompressionMode';
import SliderHandle from './components/image-compare/SliderHandle';
import HomeUpload from './components/HomeUpload';
import AppSettings from './AppSettings';
import Stats from './components/Stats';
import UploadButton from './components/UploadButton';
import SeoSection from './HomeSeoSection';
import PageFooter from './components/PageFooter';
import ImageCompareSlider from './components/image-compare/ImageCompareSlider';

const Primary = props => {
	const subscribers = [];
	const [isMobile, setMobile] = useState(window.innerWidth < 576);
	const [subHeadingVisible, setSubheadingVisible] = useState(window.innerHeight > 700);
	const { visible } = props;
	const primaryHeader = (
		<h1 className="home-heading">
			Image compressor that uses best in class compression techniques to
			reduce image size without loss in quality.
		</h1>);

	function subscribeForProgress(fn) {
		if (typeof fn === 'function' && !subscribers.includes(fn)) {
			subscribers.push(fn);
		}
	}

	function reportProgress(progress) {
		subscribers.forEach(fn => {
			fn(progress.x / window.innerWidth);
		});
	}
	const mobile = (
		<Fragment>
			<div className={`mobile-wrap ${visible ? '' : 'hidden'}`}>
				<div className="mobile-home">
					{primaryHeader}
					<br />
					<div className="mobile-upload">
						<UploadButton
							text="UPLOAD IMAGES"
							icon="upload"
							size="large"
							type="primary"
							className="mobile-upload-btn"
						/>
						<br />
						<SelectCompressionMode showPopover={false} width={256} size="large" />
					</div>
				</div>
				<Stats />
			</div>
		</Fragment>);
	const widescreen = (
		<React.Fragment>
			<div id="drop-zone" className={`widescreen ${visible ? '' : 'hidden'}`}>
				<div className="widescreen-home-content">
					{primaryHeader}
					{ subHeadingVisible &&
						<h2 className="sub-heading">
							Using technologies developed & recommended by the companies
							like google, mozilla to compress jpeg & png image files.
						</h2>
					}
					<div>
						<div className="drag-drop-anywhere">Drag drop files anywhere</div>
						<div className="widescreen-home-actions">
							<div className="action">
								<div className="label">Upload</div>
								<HomeUpload size="large" />
							</div>
							<div className="action">
								<div className="label">Compression Level</div>
								<SelectCompressionMode width={170} showLabel={false} size="large" />
							</div>
						</div>
						<div className="libraries">
							<span>MozJPEG v3.3.1</span>
							<span>pngquant v2.12.2</span>
							<span>ECT v0.8</span>
						</div>
					</div>
				</div>
				<SliderHandle fixed selector=".ant-layout-content" reportProgress={reportProgress} />
				<ImageCompareSlider
					before={AppSettings.COMPARISON_IMAGE.originalFilePath}
					after={AppSettings.COMPARISON_IMAGE.url}
					subscribeForProgress={subscribeForProgress}
				/>
			</div>
			{ visible && <Stats /> }
		</React.Fragment>
	);
	useEffect(() => {
		if (!isMobile) {
			const dropZone = document.getElementById('drop-zone');
			dropZone.addEventListener('dragover', e => {
				e.stopPropagation();
				e.preventDefault();
				Events.ShowFileTable();
			});
		}
		setMobile(window.innerWidth < 576);
		setSubheadingVisible(window.innerHeight > 700);
	}, []);
	return (
		<React.Fragment>
			{ isMobile ? mobile : widescreen }
			{ visible && <SeoSection /> }
			{ visible && <PageFooter /> }
		</React.Fragment>
	);
};

export default Primary;



// WEBPACK FOOTER //
// ./src/Primary.js